export default function (rank, countries_with_rank) {
  if (isNaN(rank)) {
    return 0;
  }
  return parseInt((1 - (rank - 1) / (countries_with_rank-1)) * 100, 10);
}
